<div
  class="d-flex align-items-center yes-no-height"
  [formGroup]="parentFormGroup"
>
  <div class="w-50">{{ formElementModel.label + asterisk }}</div>
  <mat-radio-group
    class="d-flex justify-content-center w-50"
    [formControlName]="formElementModel.id"
  >
    <mat-radio-button [value]="true" class="mr-4">Yes</mat-radio-button>
    <mat-radio-button [value]="false">No</mat-radio-button>
  </mat-radio-group>
</div>
<app-validation-error
  [control]="control"
  [formElementModel]="{
    id: formElementModel.id,
    errorMessages: { required: 'Please select an option.' }
  }"
>
</app-validation-error>
